module.exports = __webpack_public_path__ + "img/logo.a4b4bd55.svg";